import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'

const DataObservatoryPage = lazy(() => import('./DataObservatoryPage'))

const routes = {
  path: 'data-observatory',
  element: (
    <LazyLoad>
      <AuthenticatedRoute element={<DataObservatoryPage />} />
    </LazyLoad>
  )
}
export default routes
